import React from 'react';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import verticalIcon from '../../../../../assets/image/vertical-icon.svg';
import { hasPermission } from '../../../../../utils/controller';
import { useSelector } from 'react-redux';

export default function AccountListTable({
	columns,
	row,
	sortDataList,
	sortDirection,
	setAccountId,
	onRowClick,
	setIsOpenAccountsModal,
	setIsOpenDeactivateConfirmAccountModal,
	accountType,
	setIsOpenDeleteModal,
	setIsOpenActivateAccountModal,
}) {
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const getStatusText = (status) => {
		switch (status) {
			case 1:
			case '1':
				return 'Active';
			case 0:
			case '0':
				return 'Inactive';
			default:
				return '';
		}
	};

	const getStatusColor = (status) => {
		switch (status) {
			case 1:
			case '1':
				return '#68C230';
			case 0:
			case '0':
				return '#FF0000';
			default:
				return '';
		}
	};

	const getDisabled = (option) => {
		const permissionMap = {
			View: 'accounting.accounts.view',
			Delete: 'accounting.accounts.delete',
			Edit: 'accounting.accounts.edit',
			Activate: 'accounting.accounts.edit',
			Deactivate: 'accounting.accounts.edit',
		};

		const permission = permissionMap[option];

		return permission && !hasPermission(permission, user?.role?.role_permissions) ? 'disabled' : '';
	};

	const dropdownActiveOptions = ['View', 'Edit', 'Delete', 'Activate'];
	const dropdownDeactiveOptions = ['View', 'Edit', 'Delete', 'Deactivate'];

	return (
		<div
			className="table-container"
			style={{
				height:
					accountType === 'accounts'
						? 'calc(100vh - 236px)'
						: accountType === 'accounts-list'
							? 'calc(100vh - 185px)'
							: 'calc(100vh - 150px)',
			}}
		>
			<table className="custom-table">
				<thead>
					<tr>
						{columns.map((m, idx) => (
							<th
								key={idx}
								className="cursor-pointer"
								onClick={() => {
									sortDataList({ order_by: m.key });
								}}
							>
								<div className="fs-5 fw-bold d-flex justify-content-start align-items-center gap-4">
									{m.label}
									{sortIconMap[sortDirection[m.key]]}
								</div>
							</th>
						))}
					</tr>
				</thead>

				<tbody>
					{row.map((rowItem, i) => (
						<tr key={i}>
							{columns.map((m, idx) => {
								if (m.key !== 'action') {
									return (
										<td
											key={`${i}-${idx}`}
											className="fs-5 fw-light cursor-pointer"
											style={{
												color: m.key === 'status' ? getStatusColor(rowItem[m.key]) : '#000',
											}}
											onClick={() => {
												onRowClick(rowItem.id);
											}}
										>
											{m.key === 'status' ? getStatusText(rowItem[m.key]) : rowItem[m.key]}
										</td>
									);
								}

								return accountType === 'accounts' || accountType === 'accounts-list' ? (
									<td
										key={`${i}-${idx}`}
										onClick={(e) => e.stopPropagation()}
									>
										<div className="dropdown d-flex justify-content-center">
											<button
												type="button"
												className="border-0 bg-transparent p-0 justify-content-center"
												id={`dropdown-${rowItem.id}`}
												data-bs-toggle="dropdown"
												aria-expanded="false"
												onClick={(e) => e.stopPropagation()}
											>
												<img
													src={verticalIcon}
													alt="icon"
													width="20"
													height="20"
													className="rounded-circle cursor-pointer"
												/>
											</button>
											<ul
												className="dropdown-menu dropdown-menu-center"
												aria-labelledby={`dropdown-${rowItem.id}`}
											>
												{(rowItem.status === 0
													? dropdownActiveOptions
													: dropdownDeactiveOptions
												).map((option, index) => (
													<li key={index}>
														<div
															className={`p-2 dropdown-item border-0 fs-5 fw-light ${getDisabled(option)}`}
															onClick={(e) => {
																e.stopPropagation();
																if (
																	option === 'View' &&
																	hasPermission(
																		'accounting.accounts.view',
																		user?.role?.role_permissions,
																	)
																) {
																	onRowClick(rowItem.id);
																}
																if (
																	option === 'Edit' &&
																	hasPermission(
																		'accounting.accounts.edit',
																		user?.role?.role_permissions,
																	)
																) {
																	setIsOpenAccountsModal(true);
																}
																if (
																	option === 'Deactivate' &&
																	hasPermission(
																		'accounting.accounts.edit',
																		user?.role?.role_permissions,
																	)
																) {
																	setIsOpenDeactivateConfirmAccountModal(true);
																}
																if (
																	option === 'Activate' &&
																	hasPermission(
																		'accounting.accounts.edit',
																		user?.role?.role_permissions,
																	)
																) {
																	setIsOpenActivateAccountModal(true);
																}
																if (
																	option === 'Delete' &&
																	hasPermission(
																		'accounting.accounts.delete',
																		user?.role?.role_permissions,
																	)
																) {
																	setIsOpenDeleteModal(true);
																}
																setAccountId(rowItem.id);
															}}
														>
															{option}
														</div>
													</li>
												))}
											</ul>
										</div>
									</td>
								) : (
									<td>
										<div className="d-flex justify-content-center gap-4">
											<div
												className={`fs-5 fw-light rounded-4 px-4 py-3 ${!hasPermission('accounting.parent_accounts.edit', user?.role?.role_permissions) ? 'disabled text-gray border border-gray' : ' bg-primary text-white cursor-pointer'} `}
												onClick={(e) => {
													if (
														hasPermission(
															'accounting.parent_accounts.edit',
															user?.role?.role_permissions,
														)
													) {
														// onRowClick(rowItem.id);
														setIsOpenAccountsModal(true);
														setAccountId(rowItem.id);
													}
												}}
											>
												{'Edit'}
											</div>
											<div
												className={`fs-5 fw-light rounded-4 px-4 py-3    ${!hasPermission('accounting.parent_accounts.delete', user?.role?.role_permissions) ? 'disabled text-gray border border-gray' : ' bg-danger text-white cursor-pointer'}`}
												onClick={(e) => {
													if (
														hasPermission(
															'accounting.parent_accounts.delete',
															user?.role?.role_permissions,
														)
													) {
														setIsOpenDeactivateConfirmAccountModal(true);
														setAccountId(rowItem.id);
													}
												}}
											>
												{'Delete'}
											</div>
										</div>
									</td>
								);
							})}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
